import http from '@/api/http';
import { Company } from '@/types/Company';
import { Paging, Pageable } from '@/types/Page';
export { Paging, Pageable, Company };
export function getCompanyPage(params) {
    return http.get(`/company`, { params });
}
export function getCompanyById(companyId) {
    return http.get(`/company/${companyId}`);
}
export const addCompany = (company) => {
    return http.post(`/company`, company);
};
export function updateCompany(company) {
    return http.post(`/company`, company);
}
export function createApiKey(company) {
    return http.put(`/company/${company.companyId}/apikey`);
}
